/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import DataTable from "../../../Components/DataTable/DataTable";
import {
	getIcon,
	getStatusColor,
	toMoney,
} from "../../../Components/Functions";
import Layout from "../../../Components/Layout";
import TimeSummary from "../../../Components/TimeSummary";
import { DatePicker } from "../../../Components/Utils";
import { loggedUser } from "../../../Constants/menus";
import { routers } from "../../../Constants/routers";
import { to12hr } from "../../../Helpers/timeIntervals";
import {
	updateAppointsFilters,
	updateRecords,
} from "../../../Redux/MyAppointments/actions";
import { timeToShorts } from "./Dashboard";

export const MyAppointmentItem = (props) => {
	const patient =
		loggedUser?.id === props?.specialist
			? props?.patient_info
			: props?.specialist_info;

	return (
		<div className="flex-table-item">
			<div className="flex-table-cell is-media is-grow">
				<div className="h-avatar is-medium">
					<img
						className="avatar"
						src={
							patient?.image ||
							require("../../../assets/images/placeholder.png").default
						}
						alt=""
					/>
					{/* <div
						className="badge bg-success"
						style={{ width: 15, height: 15, borderRadius: 15 }}
					/> */}
				</div>
				<div>
					<span className="item-name dark-inverted" data-filter-match>
						{patient?.name}
					</span>
					<span className="item-meta">
						{patient?.role === "SPECIALIST" ? (
							<span data-filter-match>
								<a
									href={routers?.pages?.doctor(patient?.username)}
									target="_blank"
									className="action-link" rel="noreferrer"
								>
									@{patient?.username}
								</a>
							</span>
						) : (
							<span data-filter-match>@{patient?.username}</span>
						)}
					</span>
				</div>
			</div>
			<div className="flex-table-cell" data-th="Contact Info">
				<span className="light-text" data-filter-match>
					{patient?.email}
					<br />
					<small>{patient?.phone}</small>
				</span>
			</div>
			<div className="flex-table-cell" data-th="Date & Time">
				<span className="light-text" data-filter-match>
					{props.date_time}
				</span>
			</div>
			<div className="flex-table-cell" data-th="Date & Time">
				<TimeSummary {...props} />
			</div>
			<div className="flex-table-cell" data-th="Date & Time">
				<span className="light-text" data-filter-match>
					{toMoney(props?.transaction?.amount)}
					<br />
					<span
						className={`tag is-${getStatusColor(
							props?.transaction?.status,
						)} is-elevated`}
						data-filter-match
						style={{ fontSize: 8 }}
					>
						{props?.transaction?.status}
					</span>
				</span>
			</div>
			<div className="flex-table-cell" data-th="Status">
				<span
					className={`tag is-${getStatusColor(props?.status)} is-elevated`}
					data-filter-match
				>
					{props?.status}
				</span>
			</div>

			<div className="flex-table-cell cell-end" data-th="Actions">
				{(props?.status === "ACCEPTED" && props?.transaction?.status === "SUCCESS") ? (
					// <TableItemOptions options={options} />
					<button
						className="button icon-button is-circle is-dark-outlined"
						onClick={() => {
							window.location = routers.others.video_call(props?.meeting_id);
						}}
					>
						<span
							className="icon is-small"
							dangerouslySetInnerHTML={{
								__html: getIcon("chevron-right"),
							}}
						></span>
					</button>
				) : (
					""
				)}
			</div>
		</div>
	);
};

const MyAppointments = (props) => {
	const updateMyAppoints = (e) => {
		props.updateAppointsFilters({ ...props?.myappointments, ...e });
	};

	const [tableParams, setTableParams] = React.useState({});

	return (
		<Layout
			pageContentClass={"tabs-wrapper is-slider is-squared is-inverted"}
			title={"My Appointments"}
		>
			<div className="list-flex-toolbar is-reversed">
				<div className="buttons control has-icon">
					<div className="button no-bg">
						<DatePicker
							callback={(d) => {
								setTableParams({ ...tableParams, date: d });
							}}
							// type={2}
						/>
					</div>
				</div>

				<div className="tabs-inner">
					<div className="tabs">
						<ul>
							<li
								data-tab="active-items-tab"
								className={
									props?.myappointments?.view === "all" ? "is-active" : ""
								}
							>
								<a
									onClick={(e) => {
										e.preventDefault();
										updateMyAppoints({ view: "all" });
									}}
								>
									<span>All</span>
								</a>
							</li>
							<li
								data-tab="inactive-items-tab"
								className={
									props?.myappointments?.view === "upcoming" ? "is-active" : ""
								}
							>
								<a
									onClick={(e) => {
										e.preventDefault();
										updateMyAppoints({ view: "upcoming" });
									}}
								>
									<span>Up Coming</span>
								</a>
							</li>
							<li className="tab-naver" />
						</ul>
					</div>
				</div>
			</div>
			<div className="page-content-inner nobg-table">
				<div className="flex-list-wrapper flex-list-v1">
					<div className="flex-table">
						{/*Table header*/}
						<div className="flex-table-header" data-filter-hide>
							<span className="is-grow">User</span>
							<span>Contact</span>
							<span>Date</span>
							<span>Time Slots</span>
							<span>Payment</span>
							<span>Status</span>
							<span className="cell-end">Actions</span>
						</div>

						<DataTable
							header={[]}
							options={{
								allowRemove: false,
								allowBulkSelect: false,
								disableToolBar: true,
								disablePagination: false,
								removeEndPoint: "",
								endpoint: {
									url: `/users/${loggedUser?.username}/appointments/`,
									params: tableParams,
								},
								left: [],
								right: [],
							}}
							renderItem={(e) => {
								return <MyAppointmentItem {...e} />;
							}}
						/>
					</div>
				</div>
			</div>
		</Layout>
	);
};

const mapStateToProps = ({ myappointments }) => {
	return { myappointments };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateAppointsFilters: (e) => dispatch(updateAppointsFilters(e)),
		updateRecords: (e) => dispatch(updateRecords(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAppointments);
